/**
 * Helpers shared by the reducer and the per-action modules. Not exported from
 * the package.
 */
import { rulesError } from './errors.js';
export const fail = (code, message) => ({
    ok: false,
    error: rulesError(code, message),
});
export const succeed = (state, events) => ({
    ok: true,
    state,
    events,
});
export function updatePlayer(state, id, fn) {
    return { ...state, players: state.players.map((p) => (p.id === id ? fn(p) : p)) };
}
export function playerOf(state, id) {
    const p = state.players.find((x) => x.id === id);
    if (!p)
        throw new Error(`no player ${id}`);
    return p;
}
export function currentPlayer(state) {
    return playerOf(state, state.current);
}
export function addVp(state, id, vp) {
    return updatePlayer(state, id, (p) => ({ ...p, vp: p.vp + vp }));
}
/**
 * The head of the pending-action queue has been resolved (performed or
 * skipped): drop it and move to the next pending action, or to the
 * extra-action step when the queue is empty.
 */
export function afterAction(state) {
    const [, ...rest] = state.pendingActions;
    const next = rest[0];
    const phase = next && 'action' in next
        ? { kind: 'awaitAction', action: next.action }
        : { kind: 'awaitExtraAction' };
    return { ...state, pendingActions: rest, phase };
}
//# sourceMappingURL=internal.js.map